import { render, staticRenderFns } from "./FIcon.vue?vue&type=template&id=60363b99&scoped=true"
import script from "./FIcon.vue?vue&type=script&lang=js"
export * from "./FIcon.vue?vue&type=script&lang=js"
import style0 from "./FIcon.vue?vue&type=style&index=0&id=60363b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60363b99",
  null
  
)

export default component.exports